import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BidiModule } from '@angular/cdk/bidi';

import { AngularMaterialModule } from '../angular-material.module';
import { ErrorComponent } from '../error/error.component';
import { NavigationFromPrintingTableComponent } from '../main-section/settings-area/navigate-dropdown/navigation-from-printingtable/navigation-from-printingtable.component';
import { PaperTooltipContentComponent } from '../main-section/printing-table/tooltips/paper-tooltip.component';
import { MaterialTooltipContentComponent } from '../main-section/ph-printing-table/tooltips/material-tooltip.component';

/**
 * קומפוננטות משותפות לזרימת הדפסה + PH שנשארות גם ב־AppModule (print, ניווט)
 * וגם נטענות עם מודולי ה־lazy של product / phprint / chat.
 */
@NgModule({
  declarations: [
    ErrorComponent,
    NavigationFromPrintingTableComponent,
    PaperTooltipContentComponent,
    MaterialTooltipContentComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    AngularMaterialModule,
    BidiModule,
  ],
  exports: [
    NavigationFromPrintingTableComponent,
    PaperTooltipContentComponent,
    MaterialTooltipContentComponent,
  ],
})
export class PhLazySharedModule {}
